/**
 * 函数描述：js调用webview事件
 *
 * JSBridge.callHandler(method, data, callBack(response));
 * @param method {string} 方法名
 * @param data {Object} 参数
 * @return {Object} 回调
 */

/**
 * 函数描述：webView调用JS事件
 *
 * JSBridge.registerHandler(method, callBack(response));
 * @param method {string} 方法名
 * @return {Object} 回调
 */

export const JSBridge = {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, 'JSBridge', { value: JSBridge })
  },

  init: function (callback) {
    if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge) }
    if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback) }
    window.WVJBCallbacks = [callback]
    var WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'https://__bridge_loaded__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0)
  },

  registerHandler: function (name, fun) {
    this.handlers.push(name)
    this.init(function (bridge) {
      bridge.registerHandler(name, fun)
    })
  },

  callHandler: function (name, data, fun) {
    this.init(function (bridge) {
      bridge.callHandler(name, data, fun)
    })
  }
}

/**
 *
 * 通过JSBridge和助手交互的接口
 *
 */

// 告知uuid
export const setUUID = (uuid) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'setuuid',
      { value: uuid },
      res => resolve(res)
    )
  })
}

// 设置keychain
export const setKeyChain = (key, val) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'setkeychain',
      { key: val },
      res => resolve(res)
    )
  })
}

// 获取keychain
export const getKeyChain = (params) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'getkeychain',
      params,
      res => resolve(res)
    )
  })
}

// 打开第三方应用
export const openAPP = (bid, url) => {
  let urls = []
  if (url) {
    urls = [
      {
        url: url,
        retry_cnt: '3', // 重试次数
        retry_sec: '3' // 几秒后重试
      }
    ]
  }
  return new Promise(resolve => {
    JSBridge.callHandler(
      'openapp',
      {
        bundleid: bid,
        method: {
          'class': 'LSApplicationWorkspace',
          'classmethod': 'defaultWorkspace',
          'objectmethod': 'openApplicationWithBundleID:'
        },
        urls: urls,
        delay: '0' // 默认延迟1秒
      },
      res => resolve(res)
    )
  })
}

// 获取公用信息
export const getCommonInfo = (keys) => {
  let params = keys
  if (params.length === 0) {
    params = ['IDFA', 'DeviceModel', 'OSVer', 'BundleID', 'BundleVer', 'BundleBuild', 'appDSID', 'UUID', 'WebVer']
  }
  return new Promise(resolve => {
    JSBridge.callHandler(
      'getcomminfo',
      params,
      res => resolve(res)
    )
  })
}

// 设置webview背景色
export const setWebViewBGColor = (color) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'setwebviewbackground',
      {
        bgcolor: color,
        bgcoloralpha: '1'
      },
      res => resolve(res)
    )
  })
}

// 刷新按钮设置
export const setRefreshBtn = (params) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'refreshsetting',
      params,
      res => resolve(res)
    )
  })
}

// 微信分享
export const shareWX = (title, content, img, url, appID, type) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'share',
      {
        type: type,
        title: title,
        content: content,
        imageurl: img,
        url: url,
        appinfo: {
          'appID': appID
        }
      },
      res => resolve(res)
    )
  })
}

export const showNewComer = (url) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'safarisharedurl',
      { url: url },
      res => resolve(res)
    )
  })
}

export const setPasteBoard = (content) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'setpasteboard',
      { content: content },
      res => resolve(res)
    )
  })
}

export const startNotify = () => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'startnotification',
      { },
      res => resolve(res)
    )
  })
}

export const relayPlugInstalls = (bids, url) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'installs',
      {
        'bids': bids,
        'params': [
          'applicationDSID',
          'bundleIdentifier'
        ],
        'url': url
      },
      res => resolve(res)
    )
  })
}

export const setConfig = () => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'setconfig',
      {
        'allin': 'allInstalledApplications',
        'apfi': 'applicationProxyForIdentifier:',
        'appd': 'applicationDSID',
        'plugin': 'installedPlugins',
        'proxy': 'LSApplicationProxy',
        'workspace': 'LSApplicationWorkspace@defaultWorkspace()',
        'DSID': 'LSBundleProxy@bundleProxyForCurrentProcess()@applicationDSID()',
        'container': 'NSBundle@bundleWithPath:(/System/Library/PrivateFrameworks/MobileContainerManager.framework)',
        'acm': 'MCMAppContainer@containerWithIdentifier:error:(###,NULL)'
      },
      res => resolve(res)
    )
  })
}

// 应用外打开URL
export const openUrlOutAPP = (url) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'openurl',
      {
        'url': url
      },
      res => resolve(res)
    )
  })
}

// 微信绑定
export const authWechat = (type, appID) => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'login',
      {
        type: type,
        appinfo: {
          'appID': appID
        }
      },
      res => resolve(res)
    )
  })
}

//
export const getAuthTime = () => {
  return new Promise(resolve => {
    JSBridge.callHandler(
      'getapptime',
      {},
      res => resolve(res)
    )
  })
}
